import { render, staticRenderFns } from "./input-cell.vue?vue&type=template&id=20ba2440&scoped=true"
import script from "./input-cell.vue?vue&type=script&lang=js"
export * from "./input-cell.vue?vue&type=script&lang=js"
import style0 from "./input-cell.vue?vue&type=style&index=0&id=20ba2440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba2440",
  null
  
)

export default component.exports